export default {
  faq: "常见问题".toUpperCase(),
};
